// extracted by mini-css-extract-plugin
export default {"Instructions":"AppointmentAction_Instructions__5PhHr","ConfirmCancelButton":"AppointmentAction_ConfirmCancelButton__5ryk2"};